// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { xMergeWithCss } from "@sc/App/Widgets/DesignSystem/Utilities";
import React, { FC, PropsWithChildren, useState } from "react";
import { css } from "styled-components";

const sectionTitleStyles: { title?: TypographyPresentationProps } = {
    title: {
        forwardAs: "h3",
        size: 26,
        weight: "bold",
        css: css`
            width: 100%;
            border-bottom: 1px solid ${getColor("common.border")};
            margin-bottom: 20px;
        `,
    },
};

export const SectionTitle: FC<PropsWithChildren<{ extendedStyles?: { title?: TypographyPresentationProps } }>> = ({
    extendedStyles,
    children,
}) => {
    const [styles] = useState(() => xMergeWithCss(sectionTitleStyles, extendedStyles));
    return <Typography {...styles.title}>{children}</Typography>;
};

export const SectionContainer: FC<PropsWithChildren<{ extendedStyles?: { gridContainer?: GridContainerProps } }>> = ({
    extendedStyles,
    children,
}) => {
    const [styles] = useState(() => xMergeWithCss({ gridContainer: { gap: 30 } }, extendedStyles));
    return <GridContainer {...styles.gridContainer}>{children}</GridContainer>;
};
